import { ReactNode } from 'react';

import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

import { Page } from '../Page/Page';
import { PageHeaderPrimary } from '../../components/PageHeader';
import { PageFooter } from '../../components/PageFooter';

export type PrimaryPageProps = {
  children: ReactNode;
  title: string | null;
  back?: string;
  backLabel?: string;
  footer?: ReactNode;
};

const Content = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

export const PrimaryPage = ({
  children,
  back,
  backLabel,
  title,
  footer,
}: PrimaryPageProps) => {
  return (
    <>
      <PageHeaderPrimary>
        <PageHeaderPrimary.Back
          backLabel={backLabel}
          back={back}
          title={
            title === null
              ? null
              : title || <Skeleton height={38} borderRadius={2} />
          }
        />
      </PageHeaderPrimary>
      <Page>
        {/* additional div for correct scroll behavior */}
        <Content>{children}</Content>
      </Page>
      {footer ? <PageFooter>{footer}</PageFooter> : null}
    </>
  );
};
